import Navbar from './Navbar'
import Footer from './Footer'
import { BUSINESS } from '../../constants/business'

export default function Layout({ children }) {
  return (
    <>
      <a href="#main-content" className="skip-to-content">Skip to main content</a>
      <Navbar />
      <main id="main-content" tabIndex="-1">
        {children}
      </main>
      <Footer />

      {/* Mobile floating call button */}
      <a
        href={`tel:${BUSINESS.phone}`}
        className="lg:hidden fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-brand-brown text-white px-4 py-3 rounded-full shadow-xl font-heading font-bold text-sm btn-phone-pulse focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-brown"
        aria-label={`Call us now at ${BUSINESS.phoneFormatted}`}
      >
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
          <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81a19.79 19.79 0 01-3.07-8.67A2 2 0 012.18 1h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.15a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
        </svg>
        Call Now
      </a>
    </>
  )
}
